import styled, { css } from 'styled-components';

export const Breadcrumbs = styled.ol<{ $inverse: boolean }>(
  ({ theme, $inverse }) => css`
    width: 100%;
    max-width: unset;
    padding: 0; // resets default ol styles
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};
    margin: 0; // resets default ol styles
    margin-top: ${theme.sz.s4};
    margin-bottom: ${theme.sz.s4};
    color: ${$inverse ? theme.co.primary99 : theme.co.secondary20};
    ${theme.typography.heading.mobile.xxs}
    list-style: none;
    white-space: nowrap;
    overflow-x: scroll;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (min-width: ${theme.sz.md}) {
      padding-left: ${theme.sz.s12};
      padding-right: ${theme.sz.s12};
      margin-top: ${theme.sz.s8};
      margin-bottom: ${theme.sz.s8};

      ${theme.typography.heading.desktop.xxs}

      white-space: unset;
      overflow-x: unset;
    }

    @media (min-width: 1200px) {
      max-width: 1152px;
      margin-left: auto;
      margin-right: auto;
      padding-left: ${theme.sz.s6};
      padding-right: ${theme.sz.s6};
    }
  `,
);
